import ProjectsList from "./ProjectsList";

export default ProjectsList;
